import React from 'react'
import { Typography } from '@mui/material'
import { CanvasMigrationProgressView } from '../CanvasMigration/CanvasMigrationProgressView'
import { useCanvasMigrationJob } from '../CanvasMigration/useCanvasMigrationJob'
import { useStyles } from './AdminCanvasMigrationMonitor.styles'

/**
 * Admin-only live view of an in-progress Native→Canvas migration.
 * Progress cards only; no Start or Retry (partner acts from Canvas).
 */
export const AdminCanvasMigrationMonitor: React.FC<{
  partnerId: string
  crmId: string
}> = ({ partnerId, crmId }) => {
  const { classes } = useStyles()
  const { job, statusError } = useCanvasMigrationJob({
    partnerIdOverride: partnerId,
    crmIdOverride: crmId,
  })

  return (
    <div className={classes.root} data-testid="admin-canvas-migration-monitor">
      <div className={classes.header}>
        <Typography className={classes.title} component="h2">
          Data Migration Console
        </Typography>
      </div>

      {statusError ? (
        <Typography
          className={classes.statusError}
          data-testid="admin-canvas-migration-status-error"
        >
          {statusError}
        </Typography>
      ) : (
        <CanvasMigrationProgressView job={job} />
      )}
    </div>
  )
}
